import { Module } from 'vuex';
import { IRootState } from '@types';

import Env from '@lib/Env';

import { AOrderApi } from '@/api';

const store: Module<null, IRootState> = {
    actions: {
        storeOrder({ commit }, projectId: number): Promise<any> {
            commit('setProjectLoading', true);

            return new Promise((resolve, reject) => {
                AOrderApi.storeOrder(projectId)
                    .then((response) => {
                        resolve(response.data.status);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    })
                    .finally(() => {
                        commit('setProjectLoading', false);
                    });
            });
        },
    },
};

export default store;
